import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Empresa } from '@/types';

interface CrmEmpresaSelectorProps {
  empresas: Empresa[];
  value: string;
  onChange: (id: string) => void;
}

/** Só renderizado para superadmin — ver useCrmEmpresaAtiva. */
export function CrmEmpresaSelector({ empresas, value, onChange }: CrmEmpresaSelectorProps) {
  return (
    <Select value={value || undefined} onValueChange={onChange}>
      <SelectTrigger className="h-8 w-[220px]">
        <SelectValue placeholder="Selecione a empresa" />
      </SelectTrigger>
      <SelectContent>
        {empresas.map((emp) => (
          <SelectItem key={emp.id} value={emp.id}>
            {emp.nome}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
